import { render, staticRenderFns } from "./TabGeneralProtocol.vue?vue&type=template&id=17318e38&scoped=true"
import script from "./TabGeneralProtocol.vue?vue&type=script&lang=js"
export * from "./TabGeneralProtocol.vue?vue&type=script&lang=js"
import style0 from "./TabGeneralProtocol.vue?vue&type=style&index=0&id=17318e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17318e38",
  null
  
)

export default component.exports